import React from 'react'

/* doc
---
title: LevelLeft
name: LevelLeft
category: React - Bulma
parent: Level
---

A `LevelLeft` component based on Bulma `.level-left`. This should be used as a
child of `Level`. Pulls content in a `Level` to the left.

See [Bulma Documentation](http://bulma.io/documentation/components/level/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Level>
    <LevelLeft>
      ...
    </LevelLeft>
    <LevelRight>
      ...
    </LevelRight>
  </Level>
```
*/
function LevelLeft(props) {
  const { children, className, ...rest } = props

  const classes = [
    'level-left',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default LevelLeft
